var DEFAULT_DATE_LOCALE = null;
export function setDefaultDateLocale(locale) {
  DEFAULT_DATE_LOCALE = locale;
}
export function getDateLocale(locale) {
  if (locale != null) {
    return locale;
  }

  if (DEFAULT_DATE_LOCALE != null) {
    return DEFAULT_DATE_LOCALE;
  }

  throw new Error('you must provide `locale` param, or call `setDefaultDateLocale` first');
}